import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Account from './components/Account';
import AdminDashboard from './components/AdminDashboard';
import CompleteSignup from './components/CompleteSignup';
import ForgotPassword from './components/ForgotPassword';
import Login from './components/Login';
import ResetPassword from './components/ResetPassword';
import SetPassword from './components/SetPassword';
import SignupExistingUserStripe from './components/SignupExistingUserStripe';
import SignupWithInvite from './components/SignupWithInvite';
import SignupWithStripe from './components/SignupWithStripe';
import { StripeElementsRoute } from './components/StripeElementsRoute';

function App() {
    return (
        <Router>
            <div className='App'>
                <Routes>
                    <Route path='/login' element={<Login />} />
                    <Route path='/set-password' element={<SetPassword />} />
                    <Route path='/forgot-password' element={<ForgotPassword />} />
                    <Route path='/reset-password' element={<ResetPassword />} />
                    <Route path='/complete-signup' element={<CompleteSignup />} />
                    <Route path='/' element={<Navigate to='/login' replace />} />
                    <Route path='/signup-invite' element={<SignupWithInvite />} />
                    {import.meta.env.VITE_STRIPE_SIGNUPS_ENABLED === 'true' ? (
                        <>
                            <Route
                                path='/signup-new'
                                element={
                                    <StripeElementsRoute>
                                        <SignupWithStripe />
                                    </StripeElementsRoute>
                                }
                            />
                            <Route
                                path='/signup-existing'
                                element={
                                    <StripeElementsRoute>
                                        <SignupExistingUserStripe />
                                    </StripeElementsRoute>
                                }
                            />
                        </>
                    ) : null}
                    <Route path='/account' element={<Account />} />
                    <Route path='/admin' element={<AdminDashboard />} />
                    <Route path='/complete-signup' element={<CompleteSignup />} />
                    <Route path='*' element={<Navigate to='/login' replace />} />
                </Routes>
            </div>
        </Router>
    );
}

export default App;
